import React from "react";

export default function Recruitment() {
  return (
    <div className="page">
      <h1>Recruitment & Talent Acquisition</h1>
      <p>Recruitment services placeholder.</p>
    </div>
  );
}
